<template>
  <footer>
    <PDFLinkWithModal
      class="footerlink"
      file-name="mentions-legales-sagae"
      :link-text="$t('legalNotice')"
    />
    <!-- Uncomment this to allow application date
      <ApplicationDateView />
    -->
  </footer>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import PDFLinkWithModal from "@/views/commons/PDFLinkWithModal.vue"

export default defineComponent({
  name: "AppFooter",
  components: { PDFLinkWithModal },
})
</script>

<!-- Style -->
<style lang="scss" scoped>
@import "@/styles/variables.scss";

footer {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #dee2e6;
  padding: 10px;
  height: $footerHeight;
  flex-shrink: 0;
  overflow: hidden;
  z-index: 1;
}

.footerlink {
  padding-left: 10px;
  padding-right: 10px;
  font-family: $font-family-title;
  font-size: 1rem;
}
</style>
